import React from 'react';

const KOALENDAR = 'https://koalendar.com/e/meet-with-mark-bernstein';
const DILIGENTSIA = 'https://diligentsia.co.uk';

const PEHeroSection = () => (
    <section className="lp-hero">
        <div className="lp-hero-glow lp-glow-anim" aria-hidden="true" />
        <div className="lp-hero-inner">
            <div className="lp-hero-copy">
                <div className="lp-badge" data-lp-reveal><span />For Private Equity</div>
                <h1 className="lp-h1" data-lp-reveal data-lp-delay="60">Increase portfolio<br /><span style={{ color: '#FC7785' }}>value.</span><br />Simply.</h1>
                <p className="lp-lead" data-lp-reveal data-lp-delay="120">Free to PE houses. Qualify leads faster, cut initial diligence cost, and grow portfolio company value — all in one platform.</p>
                <div className="lp-cta-row" data-lp-reveal data-lp-delay="180">
                    <a className="lp-btn lp-btn--pe-outline" href={KOALENDAR} target="_blank" rel="noopener noreferrer">Book a call</a>
                </div>
                <p className="lp-pe-hero-fine" data-lp-reveal data-lp-delay="240">Free to PE firms · Pre-diligenced deal flow · Portfolio tools</p>
            </div>

            <div className="lp-hero-art">
                <div className="lp-hero-stage lp-hero-stage--pe">
                    <div className="lp-pe-photo-wrap" style={{ height: '480px' }}>
                        <img className="lp-pe-photo" src={require('../../../../images/landing-pages/PE/pe-top-banner.png')} alt="Private equity executive" />
                    </div>
                    <div className="lp-pe-statcard lp-float" data-lp-reveal data-lp-delay="200">
                        <div className="bar" />
                        <div className="label">Access to deal flow</div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default PEHeroSection;
